import React, { useEffect } from "react";
import SearchBanner from "../components/veterinaryconditions/SearchBanner";
import SpecialityTopic from "../components/veterinaryconditions/SpecialityTopic";
import "../styles/veterinarycondistyles.css";

const VeterinaryConditions = (props) => {

  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    if (window.document.cookie.indexOf("firstTimeVetLoginDone") === -1) {
      props.history.push("/vetconsult")
      window.document.cookie = "firstTimeVetLoginDone=false";
    }
  });

  return (
    <div className="veterinarycondi">
      <SearchBanner />
      <SpecialityTopic />
    </div>
  );
};

export default VeterinaryConditions;
